import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, mergeProps as _mergeProps } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_use_clipboard = _resolveComponent("use-clipboard")!

  return (_openBlock(), _createBlock(_component_use_clipboard, { source: _ctx.source }, {
    default: _withCtx(({ copy }) => [
      (_ctx.tooltipDisabled || _ctx.alert)
        ? (_openBlock(), _createBlock(_component_v_snackbar, {
            key: 0,
            class: "share-button-snackbar",
            timeout: "3500",
            location: "top",
            activator: "#share-button",
            text: "Share link copied to clipboard. Paste to share this view!",
            color: "success",
            variant: "flat",
            "min-height": "0px",
            "min-width": "0px",
            transition: "slide-y-transition",
            "close-on-content-click": ""
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_tooltip, {
        disabled: _ctx.tooltipDisabled,
        text: "Share selected view"
      }, {
        activator: _withCtx(({ props }) => [
          _createVNode(_component_v_btn, _mergeProps({
            id: "share-button",
            "aria-label": "Get link to share selected view",
            class: "share-button",
            icon: "",
            onClick: () => {
            copy(_ctx.source);
            _ctx.$emit('share');
          }
          ,
            onKeyup: _withKeys(() => {
            copy(_ctx.source);
            _ctx.$emit('share');
          }, ["enter"])
          }, props, {
            color: _ctx.buttonColor,
            elevation: _ctx.elevation,
            size: _ctx.size,
            rounded: _ctx.rounded
          }), {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { color: _ctx.iconColor }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("mdi-share-variant", -1)
                ]))]),
                _: 1
              }, 8, ["color"])
            ]),
            _: 1
          }, 16, ["onClick", "onKeyup", "color", "elevation", "size", "rounded"])
        ]),
        _: 2
      }, 1032, ["disabled"])
    ]),
    _: 1
  }, 8, ["source"]))
}